import React, { useEffect } from "react";

import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { DataType } from "@/jenesys-types/data/enums";

import { CrudRoute } from "@/components/common/crud/CrudRoute/CrudRoute";
import { loadPlatformStatus } from "@/store/features/clientSettings/connections/connections";

export const TransactionsRoute: React.FC = () => {
  const dispatch = useDispatch();
  const { clientId } = useParams();

  useEffect(() => {
    if (clientId) {
      dispatch(loadPlatformStatus(clientId));
    }
  }, [dispatch, clientId]);

  return (
    <CrudRoute
      dataType={DataType.Transaction}
      title="Bookkeeping"
      canDelete={false}
    />
  );
};
